import CardList from "../CardList/CardList";

function Page({ title, list, isDark, setIsDark }) {
  return (
    <>
      <h1>{title}</h1>
      <CardList list={list} />
    </>
  );
}

export default Page;
